import useGetRequest from '../../../common/services/useGetRequest';

// Returns [pinnedUrlNames, isLoading, error]. pinnedUrlNames is the ordered list of extension
// url_names the current user has pinned (keyed server-side off the session).
export default function useGetPinnedExtensions() {
    return useGetRequest('/ui/users/preferences/pinned_extensions');
}
